import { StyleProp, View, ViewStyle } from "react-native";

export default function Divider(props: { color: string; style?: StyleProp<ViewStyle> }) {
  const { color, style } = props;
  return <View style={[{ width: "100%", height: 1, backgroundColor: color }, style]} />;
}
